module.exports = __webpack_public_path__ + "img/skitime3.86bd2f71.png";